<template>
    <div>
      <div class="body-products">
        <div class="body-top">Products</div>
        <el-row  style="padding-top:50px;margin: 10px 30px;">
          <el-col :span="8" class="body-products-col" v-for="item in productCategorys" :key="item.productCategoryId">
            <router-link :to="{path:item.productCategoryRouter, query:{productCategoryId:item.productCategoryId}}">
            <el-image
              style="width: 200px;height: 200px"
              :src="item.src"
              fit="contain"></el-image>
            <p class="body-products-title">{{item.productCategoryName}}</p>
            </router-link>
          </el-col>
        </el-row>
      </div>

      <div class="body-animal">
        <div class="body-animal-top">Care and Love</div>
        <el-row style="padding-top:50px;margin: 10px 30px">
          <el-col :span="8" v-for="item in animalImgList" :key="item.src">
            <el-image
                    style="width: 350px;height: 350px"
                    :src="item.src"
                    fit="contain"></el-image>
          </el-col>
        </el-row>
      </div>

      <div class="body-us">
        <div style="background-color: #d5d7d4">
          <el-row style="padding-bottom:100px; padding-top:100px; margin-top: 50px">
            <el-col :span="10">
              <el-image
                style="height: 500px; padding-left: 30px"
                :src="require('../../assets/image/contact/us_building.jpg')"
                fit="contain"></el-image>
            </el-col>
            <el-col :span="14">
              <div class="us-top">About us</div>
              <div class="us-content">U-vigor Health has accumulated More than 10 years experiences in medical and diagnostic field.
                We are providing animal medical solutions including medical imaging system, rapid tests, patient monitors, surgical equipment and cages.
                Innovation, quality and service are our core values.
              </div>
              <el-button type="primary" @click="jump">READ MORE</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: 'HomeBody',
    data() {
        return {
          productCategorys: [],
          animalImgList: []
        }
    },
    mounted() {
    },
    methods: {
      jump () {
        this.$router.push('/aboutUs')
      },
      initCategorys() {
        let url = '/product/listCategory';
        this.getRequest(url).then(resp => {
          if (resp) {
            this.productCategorys = resp.data;
          }
        });
      }
    },
  created() {
    let url1 = '/product/listCategory';
    this.getRequest(url1).then(resp => {
      if (resp) {
        if(resp.total > 0){
          var _this = this;
          resp.data.forEach(row => {
            if(_this.productCategorys.length < 3){
              var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.productCategoryPicId;
              _this.productCategorys.push(
                      {
                        productCategoryId: row.productCategoryId,
                        src: imgUrl,
                        productCategoryName: row.productCategoryName,
                        productCategoryRouter : row.productCategoryRouter
                      }
              );
            }
          })
        }
      }
    });
    let url2 = '/pic/list?picType=2';
    this.getRequest(url2).then(resp => {
      if (resp) {
        if(resp.total > 0){
          var _this = this;
          resp.data.forEach(row => {
            if(_this.animalImgList.length < 6){
              var imgUrl = _this.baseUrl + '/pic/viewPic?picId=' + row.picId;
              _this.animalImgList.push(
                      {
                        src: imgUrl,
                        picName: row.picName
                      }
              );
            }
          })
        }
      }
    });
  }
}

</script>

<style src="../../assets/css/body.css" scoped>
</style>
